import React from 'react';
import { FaPlay } from 'react-icons/fa';
import { useCamera } from '../../context/CameraContext'; // カメラ位置取得
// 使用はグローバル CSS のクラス名に置換済み

// ログ出力を関数化
const logStepChange = (newStepValue, cameraPosition) => {
    // console.log("Step was pushed");
    // console.log("New Step Value:", newStepValue);
    // console.log("Current Camera Position:", cameraPosition);
};

// handleClick関数をコンポーネント外に分離
const handleClick = (StepValue, setStepValue, cameraPosition, setCameraPosition) => {
    const newStepValue = (StepValue + 1) % 3; // 0, 1, 2の範囲で循環
    setStepValue(newStepValue);
    logStepChange(newStepValue, cameraPosition);
    setCameraPosition(cameraPosition); // カメラ位置をリセット
};

// disabled：押させないとき（ヒントで視点が動いている間など）
function PlayButton({ StepValue, setStepValue, stepLabels, setCameraPosition, disabled = false }) {
    const { cameraPosition } = useCamera();
    // モチーフ（最後のステップ）にまだ到達していない間は、次に押すボタンとして点滅させる
    const attention = StepValue < stepLabels.length - 1 && !disabled ? ' btn--attention' : '';

    return (
        <button
            onClick={() => handleClick(StepValue, setStepValue, cameraPosition, setCameraPosition)}
            disabled={disabled}
            className={`btn btn--secondary${attention}${disabled ? ' opacity-50 cursor-not-allowed' : ''}`}
        >
            <FaPlay className="btn__icon" />
            次のステップ ({stepLabels[(StepValue + 1) % 3]})
        </button>
    );
}

export default PlayButton;